const mappingsTools = require('@/utils/mapTools')
const industryList = require('@/utils/industryList')
const DATA_MAP = {
  mainSubject: [{
      label: '国有企业',
      value: 'stateOwner'
    },
    {
      label: '民营企业',
      value: 'privately'
    },
    {
      label: '个人',
      value: 'personage'
    },
    {
      label: '其他',
      value: 'other'
    }
  ],
  operationType: [{
      label: '待转化',
      value: '0'
    },
    {
      label: '许可',
      value: '1'
    },
    {
      label: '质押',
      value: '2'
    },
    {
      label: '转让',
      value: '3'
    }, {
      label: '免费许可', //免费许可
      value: '4'
    },
  ],
  auditStatus: [{
      label: '待审核',
      value: 0
    },
    {
      label: '审核通过',
      value: 1
    },
    {
      label: '审核不通过',
      value: 2
    }
  ],
  type: [{
      label: '待转化',
      value: '0'
    },
    {
      label: '许可',
      value: '1'
    },
    {
      label: '质押',
      value: '2'
    },
    {
      label: '转让',
      value: '3'
    }
  ],
  informationType: [{
      label: '行业资讯',
      value: '1'
    },
    {
      label: '政策制度',
      value: '2'
    },
    {
      label: '产业分析',
      value: '3'
    }
  ],
  status: [{
      label: '未发布',
      value: '0'
    },
    {
      label: '已发布',
      value: '1'
    }
  ],
  industry: [{
      label: '集成电路',
      value: '1'
    },
    {
      label: '生物医药',
      value: '2'
    },
    {
      label: '人工智能',
      value: '3'
    },
    {
      label: '新能源汽车',
      value: '4'
    },
    {
      label: '高端装备制造',
      value: '5'
    },
    {
      label: '航空航天',
      value: '6'
    },
    {
      label: '新一代信息技术',
      value: '7'
    },
    {
      label: '新材料',
      value: '8'
    },
    {
      label: '新兴数字产业',
      value: '9'
    },
    {
      label: '现代农业',
      value: '10'
    },
    {
      label: '现代服务',
      value: '11'
    },
    {
      label: '专利信息情报、知识产权课题咨询研究',
      value: '12'
    },
    {
      label: '知识产权咨询研究',
      value: '13'
    },
    {
      label: '大数据应用',
      value: '14'
    },
    {
      label: '物联网、知识产权大数据',
      value: '15'
    },
    {
      label: '知识产权管理、保护和商用化',
      value: '16'
    }
  ],
  useStatus: [{
      label: '启用',
      value: '0'
    },
    {
      label: '停用',
      value: '1'
    }
  ],
  expertsType: [{
      label: '知识产权专家',
      value: '1'
    },
    {
      label: '专业技术专家',
      value: '2'
    },
    {
      label: '信息技术服务',
      value: '3'
    }
  ],
  industryList: industryList.industryList,

}
const v2Label = mappingsTools.key2Value(DATA_MAP) // 映射表数据处理

module.exports = {
  v2Label
}